var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.32,
    height: 12.88,
    viewBox: "0 0 19.32 12.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye",
    d: "M19.2,10.45A10.758,10.758,0,0,0,9.66,4.5,10.76,10.76,0,0,0,.117,10.451a1.085,1.085,0,0,0,0,.979A10.758,10.758,0,0,0,9.66,17.38,10.76,10.76,0,0,0,19.2,11.43,1.085,1.085,0,0,0,19.2,10.45ZM9.66,15.77a4.83,4.83,0,1,1,4.83-4.83A4.83,4.83,0,0,1,9.66,15.77Zm0-8.05a3.2,3.2,0,0,0-.849.127,1.605,1.605,0,0,1-2.244,2.244A3.213,3.213,0,1,0,9.66,7.72Z",
    transform: "translate(0 -4.5)",
    fill: "#4eabe9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeball);
export default __webpack_public_path__ + "static/media/eyeball.0b718f93b8be52dd94cccdbd95b63607.svg";
export { ForwardRef as ReactComponent };